export interface IPoiLocation {
	key: string;
	value?: string;
}

export const POI_URL_PARAM_ALL = 'all';

export const POI_LOCATION_URL_PARAM_ALL = 'All locations';
